import request from '@/utils/request'

// 获取字典数据
export function getDictData(dictType, dictItemName = '') {
  return request({
    url: '/api/v1/dict/type',
    method: 'post',
    data: {
      dictType: dictType,
      dictItemName: dictItemName
    }
  })
}

export function getDictList(params) {
  return request({
    url: 'v1/roles/list',
    method: 'post',
    data: params
  })
} 